export function deepCloneObject<T>(object: T): T {
  // Warning: this way of clone objects can led data loss when object have Date, Function or Regex
  return JSON.parse(JSON.stringify(object));
}
